import React from "react";
import { styles } from "./styles";

const SnackbarIcon = ({ src, ...props }) => {
  const classes = styles();
  return <img src={src} alt="" className={classes.icon} {...props} />;
};

export default SnackbarIcon;
